export const RECORDING_DATA_STALE_TIME_IN_MS = 60_000; // 1 minute
